import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export function timeFormatter(value, prefixZero = false) {
  const duration = dayjs.duration(value, 's')
  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = duration.seconds()
  let result = ('00' + seconds).slice(-2)
  if (minutes >= 0) {
    result = `${
      hours > 0 || prefixZero ? ('00' + minutes).slice(-2) : minutes
    }:${result}`
  }
  if (hours > 0) {
    result = `${prefixZero ? ('00' + hours).slice(-2) : hours}:${result}`
  }
  return result
}
